<template>
  <div>
    <el-dialog
      append-to-body
      class="uspesno-obvestilo"
      :visible.sync="dialogVabiloUspesnoPoslano"
      center>
      <div class="ikona-uspesno">
        <img src="/static/img/MojProfil/Icon-feather-check.png">
      </div>
      <div>
        <p class="navadno-besedilo krepko-center text-block-center">
          Vabilo je bilo uspešno poslano.
        </p>
      </div>
      <div style="padding-top: 10px">
        <p class="navadno-besedilo text-block-center okno-center">
          Uporabnik bo prejel obvestilo na vpisan e-naslov.
        <span class="text-block-center">
          Če bo vabilo sprejel, bo lahko urejal nastavitve ali imel pregled nad storitvami,
          za katere ste dodelili pravice.
        </span>
        </p>
      </div>
      <el-button class="gumb-brez-obrob krepko crna" @click="dialogVabiloUspesnoPoslano = false">
        Zapri
      </el-button>
    </el-dialog>
    <div style="padding-top: 30px">
      <div>
        <el-form label-width="200px" class="forma-uporabnik nova-vrstica-forma" :label-position="formaOrientacija">
          <div>
            <div style="padding-top: 20px">
              <p class="navadno-besedilo">
                Naročniki T-2 storitev lahko na portalu MOJ T-2 omogočite soupravljanje naročnine z drugimi člani
                gospodinjstva ali sodelavci v podjetju. Dodeljene pravice omogočajo dostop do izbranih
                funkcionalnosti, kot so pregled porabe in nastavitev za posamezno telefonsko številko, urejanje
                elektronskih predalov, upravljanje ePoslovanja in druge možnosti.
              </p>
            </div>
            <div style="padding-top: 20px" class="pb-3">
              <span class="navadno-besedilo">
                <b>
                  1. E-naslov uporabnika
                </b>
              </span>
            </div>
            <div>
              <p class="navadno-besedilo">
                Vpišite e-naslov uporabnika, ki mu želite dodeliti pravico. Pogoj za sprejem in upravljanje pravic
                je, da ima uporabnik ustvarjen svoj
                <a :href="povezavaRegistracija" class="primarna-barva">
                  T-2 ID</a>.
              </p>
              <div style="padding-top: 20px">
                <el-form-item label="E-naslov uporabnika">
                  <el-input placeholder="Vpišite elektronski naslov"
                            class="velikost-input"
                            :class="!emailUporabnikaEnakT2ID || 'error'"
                            v-model="emailUporabnika"
                            type="email">
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div>
            <div style="padding-top: 30px">
              <span class="navadno-besedilo">
                <b>
                  2. Izberite naročnino in priključek
                </b>
              </span>
            </div>
          </div>
          <div style="padding-top: 20px">
            <el-form-item label="Naročnina">
              <IzbirnikStranke
                :custom-style="prikazTabele === '1' ? 'width:330px' : ''"
                v-on:osvezitevIzbranihPodatkovStranke="GetStranka"/>
            </el-form-item>
            <el-form-item label="Priključek">
              <IzbirnikPrikljuckaSelect
                :custom-style="prikazTabele === '1' ? 'width:330px' : ''"
                @novIzbranPrikljucek="IzbranPrikljucekEvent($event)"
                :izbranPrikljucek="izbranPrikljucek"
                :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
              />
            </el-form-item>
          </div>
          <div>
            <div style="padding-top: 30px">
              <span class="navadno-besedilo">
                <b>
                  3. Izberite pravico in pošljite vabilo izbranemu prejemniku
                </b>
              </span>
            </div>
          </div>
          <div v-loading="pridobivanjeNaboraPravic">
            <div style="padding-top: 30px" v-if="naborPravic.length > 0">
              <el-table
                class="tabela-pravice"
                :data="naborPravic">
                <el-table-column
                  min-width="50px"
                  prop="title"
                  label="Tip">
                </el-table-column>
                <el-table-column
                  prop="description"
                  label="Opis" v-if="prikazTabele === '1'">
                </el-table-column>
                <el-table-column
                  label="Izberi">
                  <template slot-scope="scope">
                    <div class="e-naslov">
                      <el-select v-model="izbiraParametra[scope.row.permissionId]" clearable
                                 class="velikost-selecta"
                                 @clear="izbiraParametra[scope.row.permissionId] = null"
                                 v-bind:placeholder="scope.row.placeholder">
                        <el-option v-for="(data, key) in scope.row.results"
                                   :value="data.selectorValue"
                                   :label="data.selectorLabel"
                                   :key="key">
                        </el-option>
                      </el-select>
                    </div>
                    <div
                      v-if="prikazTabele === '0'"
                      class="mt-2"
                      style="display: flex; flex-direction: column; align-items: flex-start">
                      <el-button
                        class="primary gumb-potrdi"
                        :disabled="emailUporabnikaEnakT2ID || izbiraParametra[scope.row.permissionId] === null"
                        @click="DodeljevanjePravic(scope.row.permissionId)">
                          <span>
                            POŠLJI
                          </span>
                      </el-button>
                      <a class="stil-gumb-preklici" @click="izbiraParametra[scope.row.permissionId] = null"
                         v-if="izbiraParametra[scope.row.permissionId] !== null"
                         type="primary">
                        PREKLIČI
                      </a>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="right" v-if="prikazTabele === '0'" width="50px">
                  <template slot-scope="scope">
                    <el-tooltip class="item primarna-barva"
                                :content="scope.row.description"
                                placement="left">
                      <el-icon class="el-icon-info"></el-icon>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="Akcija" v-if="prikazTabele === '1'">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        class="primary gumb-potrdi"
                        :disabled="emailUporabnikaEnakT2ID || izbiraParametra[scope.row.permissionId] === null"
                        @click="DodeljevanjePravic(scope.row.permissionId)">
                        <span>
                          POŠLJI POVABILO
                        </span>
                      </el-button>
                      <a class="stil-gumb-preklici" @click="izbiraParametra[scope.row.permissionId] = null"
                         v-if="izbiraParametra[scope.row.permissionId] !== null"
                         type="primary">
                        PREKLIČI
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else>
              <div style="padding-top: 30px">
                <p>
                  Žal nimate nabora pravic.
                </p>
              </div>
            </div>
          </div>
        </el-form>
        <div style="margin-top: 100px;">
          <a :href=stranUrl class="primarna-barva" target="_blank">
            <div>
              <div id="bottom">
                <div class="postavitev-besedila-pomoc">
                  <p class="open-sans-13pt no-bold">
              <span class="desni-pomik-texta-pomoc">
                <b>
                  Potrebujete pomoč?
                </b>
              </span>
                    <br />
                    Imamo odgovore na pogosta vprašanja,
                    <br />
                    lahko nas tudi pokličete na 064 064 064.
                  </p>
                </div>
                <div class="desna-postavitev-ikone-pomoc">
                  <i class="fa fa-question-circle"></i>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Checkbox, Button, Option, Select, Radio, Form, FormItem, Input, Table, TableColumn, DatePicker, Dialog, Tooltip
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import Vue from 'vue'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import IzbirnikStranke from '../../GlobalneKomponente/IzbirnikStranke.vue'
import { DeljenjePravicPretvornik } from '../../../../../assets/js/globalne_funkcije/Pravice/DeljenjePravicPretvornik'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import {UrejenSeznamPrikljuckov} from '../../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {Obvestilo} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/Notification'
import PrivzetaVrednostLogic from '../../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
import {PrivzetaVrednostTipEnum} from '../../../../../assets/js/Enum/PrivzetaVrednostTipEnum'
import {DisabledPermissionsForMobileEnum} from '../../../../../assets/js/Enum/DisabledPermissionsForMobileEnum'
export default {
  name: 'Uporabniki',
  mixins: [PrikazVsebine, GetPodatkiIzbirnika, PridobiStranko],
  data () {
    return {
      formaOrientacija: 'left',
      mejnaSirinaTabela: 1440,
      emailUporabnika: '',
      narocninaUporabnika: '',
      prikljucekUporabnika: '',
      naborPravic: [],
      izbiraParametra: '',
      pridobivanjeNaboraPravic: false,
      dialogVabiloUspesnoPoslano: false,
      clientAgent: null,
      seznamVsehPrikljuckov: [],
      izbranPrikljucek: '',
      izbranaStrankaSap: '',
      izbranaStranka: '',
      pravice: [],
      seznam: [],
      validacija: null,
      prikazTabele: '1',
      mejnaSirina: 360,
      seznamPrikljuckovOtt: [],
      seznamPrikljuckovGrupirano: [],
      povezavaPraviceUporabniki: '',
      T2ID: '',
      emailUporabnikaEnakT2ID: false,
      enakEmailOpozorilo: 'Vnesli ste e-poštni naslov, ki že upravlja naročnino. Preverite in poskusite znova.',
      povezavaRegistracija: '',
      stranUrl: ''
    }
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    emailUporabnika: function (val) {
      this.emailUporabnikaEnakT2ID = val.toLowerCase() === this.T2ID
      if (this.emailUporabnikaEnakT2ID) {
        let paramObvestilo = {message: this.enakEmailOpozorilo}
        Obvestilo.methods.ShowWarningMessage(paramObvestilo)
      }
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    UrejenSeznamPrikljuckov,
    IzbirnikStranke,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [FormItem.name]: FormItem,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Tooltip.name]: Tooltip
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetUserData()
    this.povezavaPraviceUporabniki = povezave.BASE_URL_PRAVICE_UPORABNIKI
    this.povezavaRegistracija = povezave.BASE_URL_REGISTRACIJA
    this.stranUrl = povezave.BASE_URL_PRAVICE_UPORABNIKI
    this.validacija = new Validacija()
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    PrenosniPodatkiStranka (osebnikPodatki) {
      this.T2ID = osebnikPodatki.email
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStrankaSap = podatkiStranke.id_stranka_sap
        this.izbranaStranka = podatkiStranke.id_stranka
        this.GetPrikljuckiDovoljenja(podatkiStranke.id_stranka)
      }
    },
    IzbranPrikljucekEvent (idPrikljucek) {
      this.izbranPrikljucek = idPrikljucek
      this.NaborPravicZaDodeljevanje()
    },
    NaborPravicZaDodeljevanje () {
      this.pridobivanjeNaboraPravic = true
      this.naborPravic = []
      this.izbiraParametra = {}
      let param = ['appendResults=' + true]
      param.push('filter[id_prikljucek]=' + this.izbranPrikljucek)
      param.push('filter[id_stranka_sap]=' + this.izbranaStrankaSap)
      param.push('filter[id_stranka]=' + this.izbranaStranka)
      this.clientAgent.postWsRequest(this,
        'permissions/getAllShareablePermissions?',
        param,
        null,
        'GetNaborPravicZaDodeljevanje',
        'ErrNaborPravicZaDodeljevanje')
    },
    GetNaborPravicZaDodeljevanje (podatki, skipSetter = false) {
      if (!skipSetter) {
        this.naborPravic = DeljenjePravicPretvornik.methods.GetPretvorjenSeznamPravic(podatki.data)
      }
      let prikljucekDelPaketa = this.seznamVsehPrikljuckov.find(
        x => x.id_prikljucek === this.izbranPrikljucek && x.tip_prikljucka === 'UMTS' && x.je_nosilni === '0'
      )
      for (let i = 0; i < this.naborPravic.length; i++) {
        Vue.set(this.izbiraParametra, this.naborPravic[i].permissionId, null)
      }
      if (prikljucekDelPaketa) {
        this.naborPravic = this.naborPravic.filter(x => !DisabledPermissionsForMobileEnum.includes(x.permissionId))
      }
      this.naborPravic.sort((a, b) => {
        const moveToBottom = ['EPOSLOVANJE', 'NASTAVITVE_TELEFONIJA']
        const aIsBottom = moveToBottom.includes(a.permissionId)
        const bIsBottom = moveToBottom.includes(b.permissionId)

        if (aIsBottom && !bIsBottom) return 1
        if (!aIsBottom && bIsBottom) return -1
        return 0
      })
      this.pridobivanjeNaboraPravic = false
    },
    ErrNaborPravicZaDodeljevanje (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeNaboraPravic = false
    },
    PreveriParametre (pravica, izbiraParametra) {
      let errorMsg = {}
      if (this.emailUporabnika === '') {
        errorMsg.message = 'Vpišite elektronski naslov prejemnika'
        this.ShowWarningMessage(errorMsg)
        return false
      }
      if (izbiraParametra === null) {
        errorMsg.message = 'Izberite številko/enaslov, ki ga želite deliti'
        this.ShowWarningMessage(errorMsg)
        return false
      }
      if (pravica === null) {
        errorMsg.message = 'Izberite pravico, ki jo želite deliti'
        this.ShowWarningMessage(errorMsg)
        return false
      }
      return true
    },
    async DodeljevanjePravic (selectedPermission = null) {
      let obj = JSON.parse(JSON.stringify(this.izbiraParametra))
      let arr = []
      for (let key in obj) {
        if (obj[key] !== null && selectedPermission !== null && key === selectedPermission) {
          const object = {}
          object.id = key
          object.scope = [String(obj[key])]
          arr.push(object)
        }
      }
      if (arr.length > 0) {
        if (this.emailUporabnika === '') {
          let errorMsg = {}
          errorMsg.message = 'Vpišite elektronski naslov prejemnika'
          this.ShowWarningMessage(errorMsg)
        } else {
          try {
            await this.clientAgent.makeRequest(
              'permissions/grantPermission',
              {
                email: this.emailUporabnika,
                permissions: JSON.stringify(arr)
              }
            )
            let msg = {}
            msg.message = 'Uspešno poslana pravica.'
            this.ShowSuccessMessage(msg)
            this.GetNaborPravicZaDodeljevanje(null, true)
            this.izbiraParametra = {}
          } catch (e) {
            let errorMsg = {message: e.message}
            this.ShowWarningMessage(errorMsg)
          }
        }
      } else {
        let errorMsg = {}
        errorMsg.message = 'Izberite vsaj eno pravico iz nabora.'
        this.ShowWarningMessage(errorMsg)
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissions[]=PRIKLJUCKI']
        param.push('permissions[]=PREPAID_PRIKLJUCKI')
        this.clientAgent.postWsRequest(
          this,
          'permissions/all',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.results.PRIKLJUCKI.additionalData,
        podatki.results.PREPAID_PRIKLJUCKI.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      this.seznamPrikljuckovGrupirano = groupedList
      let shranjenPrivzetPrikljucek =
        PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK)
      if (list.find(x => x.id_prikljucek === shranjenPrivzetPrikljucek)) {
        this.izbranPrikljucek = shranjenPrivzetPrikljucek
      } else {
        list.filter(x => x.tip_prikljucka === 'FIX').forEach(prikljucek => {
          this.izbranPrikljucek = prikljucek.id_prikljucek
        })
      }
      if (this.izbranPrikljucek === '') {
        this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      }
      this.NaborPravicZaDodeljevanje()
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>

<style scoped>
.velikost-input {
  width: 330px;
}

.velikost-prikljucka{
  width: 330px;
}

/deep/ .el-form-item__label {
  font-weight: normal;
}

.odmik-gumba {
  padding-top: 50px;
}

/deep/ .el-table .cell {
  text-transform: none;
}

table, tr, td {
  padding: 25px 90px 0 0;
}

td:nth-child(4) {
  padding: 0;
}

.postavitev-vnosnih-podatkov {
  padding-top: 20px;
  padding-left: 40px;
}

#bottom {
  position: absolute;
  bottom: 0;
  right: 25px;
}

.zgornji-odmik-pomoc {
  margin-top: 90px;
  float: right;
}

.postavitev-besedila-pomoc {
  float: left;
  margin-right: 10px;
}

.fa {
  font-size: 48px;
  color: #f58220;
}

.desna-postavitev-ikone-pomoc {
  float: right;
}

.desni-pomik-texta-pomoc {
  float: right;
  text-align: right;
}

.velikost-selecta {
  width: 275px;
}

/deep/ .el-table td:nth-of-type(1) .cell, /deep/ .el-table td:nth-of-type(3) .cell, /deep/ .el-table td:nth-of-type(4) .cell {
  position: absolute;
  top:8px;
}

@media only screen and (max-width: 1600px) and (min-width: 1000px) {
  .stil-gumb-preklici {
    text-align: center;
  }
}

@media only screen and (max-width: 730px) {
  .povabilo-tekst{
    display: none !important;
  }

  .stil-gumb-preklici {
    display: block;
    text-align: center;
  }

  /deep/ .el-form-item__label {
    padding: 0 0 0 0;
    margin-bottom: -7px;
  }
  .tabela-pravice .el-button.gumb-potrdi {
    margin-left: 5px;
  }
}

@media only screen and (max-width: 600px) {
  .tabela-pravice .el-button.gumb-potrdi {
    max-width: 95px;
  }
  .postavitev-vnosnih-podatkov {
    padding-left: 0;
  }

  .velikost-input, /deep/ .el-select {
    width: 100%;
  }

  .gumb-potrdi, /deep/ .el-input__inner {
    width: 100%;
  }
}

@media only screen and (max-width: 730px) {
  /deep/ .nova-vrstica-forma .el-form-item .el-form-item__content {
    display: block;
    width: 100%;
    margin-left: 0 !important;
  }
  .tabela-pravice .el-button.gumb-potrdi {
    font-size: 13px;
  }
  .stil-gumb-preklici {
    padding: 11px 11px 11px 11px !important;
    margin-left: 5px;
  }
}

@media only screen and (min-width: 1100px)  and (max-width: 1440px) {
  .velikost-selecta, .tabela-pravice .el-button.gumb-potrdi, .stil-gumb-preklici {
    min-width: 240px;
  }
}

@media only screen and (min-width: 1440px)  and (max-width: 1610px) {
  .stil-gumb-preklici {
    width: 160px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/UporabnikiInPravice/Uporabniki.vue